/* eslint-disable react-hooks/exhaustive-deps */
import { CalendarDaysIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-lone-blocks */
import { format } from "date-fns";
/* @ts-ignore */
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css";
import { Button, Popover, Text, Group } from "@mantine/core";

type Props = {
  state: any,
  setState: any,
};

const DateRangeDropdown = ({
  state, setState,
}: Props) => {
  const [opened, setOpened] = useState<boolean>(false);

  const dateRangeText = `${format(state.selection.startDate, "do MMM yy")} → ${format(state.selection.endDate, "do MMM yy")}`;
  
  return (
    <Popover 
      shadow="md" 
      opened={opened} 
      onChange={setOpened}
      width="auto"
      position="bottom-end"
      trapFocus
    >
      <Popover.Target>
        <div className="flex flex-col">
          <Text size="xs" c="dimmed" lh={1.5}>Select date range</Text>
          <Button 
            variant="subtle" 
            classNames={{
              root: "bg-white",
            }}
            size="sm" 
            leftSection={<CalendarDaysIcon className="w-4 h-4" />}
            onClick={() => setOpened((o) => !o)}
            className="text-xs"
          >
            {dateRangeText}
          </Button>
        </div>
      </Popover.Target>
      
      <Popover.Dropdown p={0} className="border border-gray-200">
        <div className="flex flex-col">
          <DateRangePicker
            rangeColors={["#7C3AED", "#7C3AED"]}
            onChange={(item: any) => setState({ ...state, ...item })}
            showSelectionPreview
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={[state.selection]}
            direction="horizontal"
            ariaLabels={{
              monthPicker: "month",
              yearPicker: "year",
              prevButton: "previous month",
              nextButton: "next month",
            }}
          />
          <Group justify="flex-end" p="sm" className="border-t border-gray-200">
            <Button 
              size="sm" 
              leftSection={<CalendarDaysIcon className="w-4 h-4" />} 
              onClick={() => setOpened(false)}
            >
              Set Range
            </Button>
          </Group>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};

export default DateRangeDropdown;
